.toast {
  display: inline-flex;
  width: max-content;
  align-items: center;
  gap: var(--space-4);
  max-width: min(560px, calc(100vw - 2 * var(--space-4)));
  min-height: 48px;
  padding: var(--space-2) var(--space-4);
  border: var(--hairline) solid var(--separator);
  border-radius: var(--radius-card);
  background: var(--card);
  box-shadow: var(--shadow-card);
}

.message {
  flex: 1;
  padding-block: var(--space-1);
  font: var(--text-callout);
  color: var(--label);
}
